// extracted by mini-css-extract-plugin
export var bubble = "_3q-0";
export var container = "_3q-3";
export var contrastBorder = "_3q-4";
export var greyOut = "_3q-2";
export var initialsWrapper = "_3q-1";
export var large = "_3q-9";
export var medium = "_3q-8";
export var mediumSmall = "_3q-7";
export var mediumSmallMedium = "_3q-c";
export var micro = "_3q-5";
export var small = "_3q-6";
export var tiny = "_3q-b";
export var xTiny = "_3q-a";